module.exports = __webpack_public_path__ + "static/media/main_nav_check_orange.eb863be2.svg";